import React from 'react';
import type { OsobyPodnikatelSouhlasDto } from '@gov-nx/api';
import { useIcSearchAutocomplete } from '@gov-nx/core/hooks';
import {
	LocalizeNameSpaceTypes,
	useTranslationWithNamespace,
} from '@gov-nx/core/service';
import type { FormAutocompleteProps } from '../FormAutocomplete';
import { FormAutocomplete } from '../FormAutocomplete';

interface Props extends Omit<
	FormAutocompleteProps<OsobyPodnikatelSouhlasDto>,
	'field'
> {
	field: Omit<
		FormAutocompleteProps<OsobyPodnikatelSouhlasDto>['field'],
		'templateResolver' | 'keyResolver' | 'valueResolver' | 'searchCallback'
	>;
}

export const IcNumberAutocomplete = (props: Props) => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(LocalizeNameSpaceTypes.Form);
	const { searchCallback } = useIcSearchAutocomplete();

	return (
		<FormAutocomplete<OsobyPodnikatelSouhlasDto>
			label={props.label}
			field={{
				...props.field,
				messageEmpty:
					props.field.messageEmpty ?? tn('naseptavac.pole.zadny-vysledek'),
				templateResolver: (item) => item?.ico,
				keyResolver: (item) => `${item.ico}`,
				valueResolver: (item) => `${item.ico}`,
				searchCallback,
				iconStart: {
					name: 'search',
					type: 'components',
				},
			}}
		/>
	);
};
